import { TokenAdmService } from './../../services/token-adm.service';
import { VideotutorialService } from './../../services/videotutorial.service';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-videotutoriales',
  templateUrl: './videotutoriales.component.html',
  styleUrls: ['./videotutoriales.component.css'],
})
export class VideotutorialesComponent implements OnInit {

  hayVideos: boolean
  videos:any;
  loading: boolean;
  isAdmin:boolean;
  isContribuidor:boolean;
  ruta:string;
  @Input() preguntaId: number;
  @Input() respuestaId: number;

  constructor( private router:Router,
              private videotutorialService:VideotutorialService, private tokenService:TokenAdmService,
              private videoService:VideotutorialService){ }

  ngOnInit(): void {
    this.loading = true;
    this.videotutorialService.getVideosActivosByPreguntaPublic(this.preguntaId)
      .subscribe(
        resp => {
          this.videos = resp;
          if (this.videos === null || this.videos === undefined || this.videos.length ==0)
          {
              this.hayVideos = false;
          }
          else{
            this.hayVideos = true;
          }
          this.loading = false;
        },
        error => {
          console.error(error);
          this.hayVideos = false;
          this.loading = false;
        }
      )
      this.isAdmin = this.tokenService.hasRole('Help_Admin')
      this.isContribuidor = this.tokenService.hasRole('Help_Contribuidor')
  }



  nuevoVideo(){
    sessionStorage.setItem('origenVideo',location.pathname);
    this.ruta = 'help/video/0';
    this.router.navigateByUrl(this.ruta);
  }

  editarVideo(videoId:number){
    sessionStorage.setItem('origenVideo',location.pathname);
    this.ruta = 'help/video/'+videoId;
    this.router.navigateByUrl(this.ruta);
  }

  borrarVideo(videoId:number, nombre:string) {
    Swal.fire({
      title: 'Eliminar video',
      html: `¿Estas seguro que deseas borrar el siguiente videotutorial?<br>${nombre}`,
      showDenyButton: true,
      confirmButtonText: `Si`,
      denyButtonText: `No`,
      icon:'question',
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Espera por favor',
          text: 'Guardando la información',
          allowOutsideClick: false,
          timerProgressBar: true,
         });
         let timerInterval
          Swal.showLoading();
            this.videoService.eliminarVideo(videoId)
            .subscribe({
              next: data => {
                Swal.fire({
                  title: 'Videotutorial Eliminado',
                  text: `El videotutorial "${nombre}" ha sido borrado con exito`,
                  icon: 'success',
                  timer: 1500,
                  timerProgressBar: true,
                  willClose: () => {
                    clearInterval(timerInterval)
                    this.ngOnInit();
                  },
                  didOpen: () => {
                    Swal.showLoading()
                    const b = Swal.getHtmlContainer().querySelector('b')
                    timerInterval = setInterval(() => {
                      if (b){
                        b.textContent = Swal.getTimerLeft()?.toString()
                      }
                    }, 100)
                  }
                }).then(resp => {
                  if (resp.isConfirmed) {
                    this.ngOnInit();
                  }})
              },
              error: error => {
                console.error(error.error);
                Swal.fire({
                  title: 'No se pudo eliminar el videotutorial',
                  text: `Ocurrió un error al eliminar el videotutorial ${nombre}`,
                  icon: 'error',
                  confirmButtonText: 'Ok'
                })
              }
          });
        }

      })
  }


}
